// components/FloatingCursor.jsx

import React, { useState, useEffect } from 'react';

const FloatingCursor = ({ colors }) => {
  // This component will only render on the client, preventing SSR issues.
  const [hasMounted, setHasMounted] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: -200, y: -200 });

  useEffect(() => {
    setHasMounted(true);

    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };

    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  if (!hasMounted) {
    return null;
  }

  return (
    <div
      className="fixed w-72 h-72 pointer-events-none z-0 opacity-[.04] rounded-full blur-3xl transition-all duration-300"
      style={{
        left: mousePosition.x - 144,
        top: mousePosition.y - 144,
        background: `radial-gradient(circle, ${colors.primary} 0%, transparent 70%)`,
      }}
    ></div>
  );
};

export default FloatingCursor;